<!--
  ConversationsError — Phase 4-3 / T18.

  Recoverable error state for the conversation list. Heading + sub + retry.
  Compact layout, no card wrapper (the widget itself is the container).
-->
<script lang="ts">
  type Props = {
    error: unknown;
    onRetry?: () => void;
  };
  let { error, onRetry }: Props = $props();

  const detail = $derived(toMessage(error));

  function toMessage(e: unknown): string {
    if (e instanceof Error) return e.message;
    if (typeof e === 'string') return e;
    return '';
  }

  function retry() {
    onRetry?.();
  }
</script>

<div class="err" role="alert">
  <p class="heading">Could not load conversations</p>
  <p class="sub">There was a problem reaching the server. Try again in a moment.</p>
  {#if detail}
    <p class="detail" title={detail}>{detail}</p>
  {/if}
  <button type="button" class="retry" onclick={retry}>Try again</button>
</div>

<style>
  .err {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 28px;
    text-align: center;
    color: var(--widget-fg);
    height: 100%;
    box-sizing: border-box;
  }
  .heading {
    /* Label role: uppercase, tight tracking, danger color. */
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--widget-danger);
  }
  .sub {
    margin: 0;
    font-size: 12.5px;
    color: var(--widget-fg-muted);
    max-width: 34ch;
    line-height: 1.45;
  }
  .detail {
    margin: 4px 0 0;
    font-size: 11.5px;
    color: var(--widget-fg-dim);
    font-family: var(--widget-font-mono);
    max-width: 38ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /* Action button per DESIGN.md Square-for-Action Rule: 5px radius, Signal
     Amber bg, Steel FG text. Live Console hover-swap reads as a key press,
     not a color animation; no brightness filter. */
  .retry {
    margin-top: 4px;
    padding: 8px 14px;
    border-radius: var(--widget-radius-action);
    background: var(--widget-accent);
    color: var(--widget-fg);
    font-family: var(--widget-font);
    font-size: 12.5px;
    font-weight: 700;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition:
      background-color 120ms cubic-bezier(0.25, 1, 0.5, 1),
      color 120ms cubic-bezier(0.25, 1, 0.5, 1);
  }
  .retry:hover {
    background: var(--widget-accent-deep);
    color: var(--widget-bg-elevated);
  }
  .retry:active {
    opacity: 0.92;
  }
  .retry:focus-visible {
    outline: 3px solid color-mix(in oklch, var(--widget-accent) 22%, transparent);
    outline-offset: 1px;
  }
</style>
